import { Outlet, useParams } from "react-router-dom";
import { useRetrieveProfile } from "../../../data/useRetrieveProfile";

export const ApplicationFlowLayout = () => {
  const { id } = useParams<{ id: string }>();
  const profileId = Number(id);

  const profileQuery = useRetrieveProfile(profileId);
  const profile = profileQuery.data;

  if (profileQuery.isLoading) return null;
  if (!profile) return null;

  return <Outlet context={{ profile }} />;
};
